import type * as AddCatalogueOffer from '@ori-events/add-catalogue-offer';
import * as AddCatalogueOfferFailed from '@ori-events/add-catalogue-offer-failed';
import type { PositionData } from '@ori/analytics-data';
import { HttpMethod } from '@ori/checkout-utils';

import { RequestUrl } from '../types';
import { convertToCamelCase, getHttpRequestSettings } from '../utils';

type Data = AddCatalogueOffer.Data & PositionData;

export const dispatchAddCatalogueOfferFailedEvent = (detail: AddCatalogueOfferFailed.Data) => {
  const event = new CustomEvent<AddCatalogueOfferFailed.Data>(AddCatalogueOfferFailed.Name, {
    detail,
  });
  window.dispatchEvent(event);
};

export async function addCatalogueOfferHandler({ detail: { offerId, placement } }: CustomEvent<Data>) {
  const request = await fetch(
    RequestUrl.AddCatalogueOffer,
    getHttpRequestSettings({ offerId, placement }, HttpMethod.Post),
  );

  const response = convertToCamelCase<AddCatalogueOfferFailed.AddCatalogueOfferResponse>(
    (await request.json()) as object,
  );
  if (AddCatalogueOfferFailed.isAddCatalogueOfferErrorResponse(response)) {
    dispatchAddCatalogueOfferFailedEvent(response);

    return false;
  }

  return response;
}
